import { REQUEST_METHODS } from '@/constants/network'
import baseFetch from '@/network/baseFetch'
import { HTTPResponseError } from '@/types/network/common'

export const getCancellationView = async (orderId: string): Promise<any> => {
  try {
    const URL = `/orders/${orderId}/cancellation/view`
    const headers = {
      'Accept': 'application/json',
    }
    const response = await baseFetch({
      url: URL,
      method: REQUEST_METHODS.GET,
      headers
    })
    return response
  } catch (e) {
    console.log(e)
    return {}
  }
}

export const getCancellationReview = async (orderId: string, payload: Record<string, any>): Promise<any> => {
  try {
    const URL = `/orders/${orderId}/cancellation/quote`
    const headers = {
      'Accept': 'application/json',
    }
    const response = await baseFetch({
      url: URL,
      method: REQUEST_METHODS.POST,
      body: JSON.stringify(payload),
      headers
    })
    return response
  } catch (e) {
    console.log(e)
    return {}
  }
}

export const submitCancellation = async (orderId: string, payload: Record<string, any>): Promise<{ data: any }> => {
  try {
    const URL = `/orders/${orderId}/cancellation`
    const headers = {
      'Accept': 'application/json',
    }
    const data = await baseFetch({
      url: URL,
      method: REQUEST_METHODS.POST,
      body: JSON.stringify(payload),
      headers
    })
    return { data }
  } catch (error) {
    if (error instanceof HTTPResponseError) {
      return { data: error.errorResponse }
    }
    return {
      data: { error: { code: 'INTERNAL_SERVER_ERROR', message: 'An unexpected error occurred. Please try again later' } },
    }
  }
}

export const verifyUpiId = async (tripId: string, upiId: string): Promise<any> => {
  try {
    const URL = `/communication/selfcare/api/vpa-ba/verify/${tripId}`
    const response = await baseFetch({
      url: URL,
      method: REQUEST_METHODS.POST,
      body: JSON.stringify({ vpa: upiId, accountType: 'VPA' }),
    })
    return response
  } catch (e) {
    console.log(e)
    return {}
  }
}
